// ABOUTME: Atribución del probador: enlaces de compra y de invitación con UTM por canal (botón,
// ABOUTME: QR en pantalla, foto compartida) e identificador corto de cada foto para cruzar con ventas.

/** Por dónde llegó la persona a la tienda: botón «Comprar», QR de la foto en pantalla o QR/enlace de una foto compartida. */
export type Channel = "app" | "qr" | "compartido";

export interface ShotRef {
  styleId: string;
  hairstyleId: string;
  shotId: string;
}

/** Identificador corto de una foto, generado en el cliente antes de que exista el registro en Firestore. */
export function newShotId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(8));
  return Array.from(bytes, (b) => (b % 36).toString(36)).join("");
}

function withUtm(base: string, params: Record<string, string>): string {
  let url: URL;
  try {
    url = new URL(base);
  } catch {
    return base;
  }
  for (const [k, v] of Object.entries(params)) url.searchParams.set(k, v);
  return url.toString();
}

/** URL de la ficha del producto etiquetada con el canal y la foto de la que sale. */
export function buyUrl(productUrl: string, channel: Channel, shot: ShotRef): string {
  return withUtm(productUrl, {
    utm_source: "probador",
    utm_medium: channel,
    utm_campaign: shot.styleId,
    utm_term: shot.hairstyleId,
    utm_content: shot.shotId,
  });
}

/** Enlace al probador que acompaña una foto compartida, para medir a quien la recibe y se prueba la suya. */
export function tryOnUrl(origin: string, shot: ShotRef): string {
  return withUtm(origin, {
    utm_source: "foto_compartida",
    utm_medium: "compartido",
    utm_campaign: shot.styleId,
    utm_content: shot.shotId,
  });
}

export function shareText(styleName: string, url: string): string {
  return `Así me quedarían las rastas ${styleName} de Dreadlove. Probá las tuyas: ${url}`;
}
